import React from "react";

import DataTable from "components/basic/data-table/DataTable";
import { TableColumn } from "components/pages/measurement-devices/utils/types";
import { Button } from "primereact/button";
import { DatasetsSearchResult } from "types/types";
import { DEFAULT_DASHBOARD_URL, DEFAULT_REPORT_URL, HASH_ROUTER_URL } from "utils/constants";
import { T } from "services/lang/LanguageService";
import { Tag, TagProps } from "primereact/tag";

type DashboardResult = Omit<DatasetsSearchResult, "task">;

type DashboardResultTableProps = {
  results: DashboardResult[];
  loading?: boolean;
};

const DashboardResultTable: React.FC<DashboardResultTableProps> = ({ results, loading }) => {
  const renderLink = (rowData: DashboardResult) => {
    let url: string;
    switch (rowData.resultFound) {
      case "DASHBOARD":
        url = `${HASH_ROUTER_URL}/dashboard/${rowData.dashboard.id}/tab/${rowData.dashboard.tabId}`;
        return <LinkButton url={url} />;
      case "DASHBOARD_OLD":
        url = `${DEFAULT_DASHBOARD_URL}dashboardId=${rowData.dashboard.id}&tabId=${rowData.dashboard.tabId}&dashboard=${rowData.dashboard.dashboardTitle}`;
        return <LinkButton url={url} />;
      case "REPORT":
        url = `${DEFAULT_REPORT_URL}dashboardId=${rowData.dashboard.id}&tabId=${rowData.dashboard.tabId}&dashboard=${rowData.dashboard.dashboardTitle}`;
        return <LinkButton url={url} />;
      default:
        return null;
    }
  };

  const renderType = (rowData: DashboardResult) => {
    let props: TagProps = { title: rowData.resultFound };

    switch (rowData.resultFound) {
      case "DASHBOARD":
        props = { ...props, value: T("word.dashboard"), severity: "success" };
        break;
      case "DASHBOARD_OLD":
        props = { ...props, value: `${T("word.dashboard")} (old)`, severity: "warning" };
        break;
      case "REPORT":
        props = { ...props, value: T("word.report"), severity: "secondary" };
        break;
      default:
        props = { value: T("message.unknown-type"), severity: "danger" };
        break;
    }
    return <Tag {...props} />;
  };

  const dashboardColumns: TableColumn<DashboardResult>[] = [
    {
      field: "dashboard.dashboardTitle",
      header: T("word.dashboard-title"),
      columnKey: "dashboardTitle",
      sortable: true,
      filter: true,
    },
    {
      field: "dashboard.tabTitle",
      header: T("word.tab-title"),
      columnKey: "tabTitle",
      sortable: true,
      filter: true,
    },
    {
      field: "dashboard.componentTitle",
      header: T("word.component-or-group-title"),
      columnKey: "componentTitle",
      sortable: true,
      filter: true,
    },
    {
      field: "resultFound",
      header: T("word.type"),
      columnKey: "type",
      sortable: true,
      body: renderType,
    },
    {
      header: T("word.link"),
      columnKey: "link",
      body: renderLink,
    },
  ];

  return <DataTable data={results} columns={dashboardColumns} tableConfig={{ loading }} />;
};

export default DashboardResultTable;

const LinkButton = ({ url }: { url: string }) => (
  <Button
    icon="pi pi-external-link"
    className="p-button-sm p-button-text p-1"
    style={{ width: "1.3rem" }}
    onClick={() => window.open(url)}
  />
);
